/** Returns a new Map with `value` set for every key in `keys`. */
export function setMapItems<K, V>(
  map: Map<K, V>,
  keys: Iterable<K>,
  value: V,
): Map<K, V> {
  const next = new Map(map);
  for (const key of keys) next.set(key, value);
  return next;
}
